import { history } from '../store/index';
import { store } from '../../NextApp';
import { message } from 'antd';
import { generateQueryString } from "../../util/Api";

import {
    CREATE_ORGANISATION_SUCCESS,
    FETCH_ORGANISATION_IMPORT_SUCCESS, FETCH_ORGANISATION_SPARE_IMPORT_SUCCESS,
    FETCH_ORGANISATION_SUCCESS,
    GET_ORGANISATION_SUCCESS,
    SAVE_ORGANISATION_QUERY
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import { arrayToCSV, downloadCSV } from "../../util/methods";
import Swal from "sweetalert2";

export const getResourceSuccess = ({ data, count }) => {
    return {
        type: GET_ORGANISATION_SUCCESS,
        data,
        count
    };
};

export const saveResourceQuery = (query) => {
    return {
        type: SAVE_ORGANISATION_QUERY,
        query
    };
};

export const createResourceSuccess = ({ data }) => {
    return {
        type: CREATE_ORGANISATION_SUCCESS,
        data
    };
};

export const fetchResourceSuccess = ({ data }) => {
    return {
        type: FETCH_ORGANISATION_SUCCESS,
        data
    };
};

export const fetchImportSuccess = (data) => {
    return {
        type: FETCH_ORGANISATION_IMPORT_SUCCESS,
        data
    };
};

export const fetchSpareImportSuccess = (data) => {
    return {
        type: FETCH_ORGANISATION_SPARE_IMPORT_SUCCESS,
        data
    };
};

export const assetDataImport = (payload) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const { isRemove } = payload;
            if (!isRemove) {
                let formData = new FormData();
                formData.append('organisation', payload.organisation);
                formData.append('files', payload.file);

                const response = await axios.post(`/purchase-order/import`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
                dispatch(fetchSuccess());
                if (response && response.data && response.data.code === 200) {
                    const { data } = response.data;
                    // console.log(data);
                    message.success(`${data.length} - PI record created`);
                    downloadJSONFile({
                        data: JSON.stringify(data, null, 1),
                        fileName: 'pi-import' + new Date().getTime() + '.json',
                        fileType: 'text/json',
                    });
                    console.log(JSON.stringify(data, null, 1));
                    dispatch(fetchImportSuccess(data));
                } else if (response && response.data && response.data.code === 401) {
                    message.error(`Something went wrong, please verify results in PI`);
                }
            } else {
                console.log(`Organisation data removing...`);
                const response = await axios.get(`/purchase-order/reverse-import/${payload.organisation}`);
                message.success(JSON.stringify(response.data, null, 1));
                console.log(JSON.stringify(response.data, null, 1));
                dispatch(fetchSuccess());
            }
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    }
};

const downloadJSONFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });
    const a = document.createElement('a');
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove()
};


export const getResource = () => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const { organisation } = store.getState();
            const { query } = organisation;
            const response = await axios.get(`/organisation?${generateQueryString(query)}`);
            // console.log(response.data);
            dispatch(fetchSuccess());
            if (response && response.data) {
                dispatch(getResourceSuccess(response.data));
            }
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const getResourceForImport = () => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const { organisation } = store.getState();
            const { query } = organisation;
            const response = await axios.get(`/organisation/all?${generateQueryString(query)}`);
            // console.log(response);
            dispatch(fetchSuccess());
            if (response && response.data) {
                dispatch(getResourceSuccess(response));
            }
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const getResourceForDownload = (columns, filters, name) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            const { organisation } = store.getState();
            const { query } = organisation;
            const response = await axios.get(`/organisation/download?columns=${columns}&${generateQueryString(query)}`);
            dispatch(fetchSuccess());
            const str = arrayToCSV(response.data, filters, columns)
            downloadCSV(str, name);
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const createResource = (payload) => {
    return async (dispatch) => {

        dispatch(fetchStart());
        try {
            let formData = new FormData();
            // formData.append('name', payload.name);
            formData.append('files', payload.files.file);
            formData.append('filesFavicon', payload.filesFavicon.file);

            Object.keys(payload).forEach(key => {
                if (key === 'files' || key === 'filesFavicon') {
                    return
                }
                formData.append(key, payload[key]);
            });

            const response = await axios.post(`/common/organisation/create`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
            dispatch(fetchSuccess());

            dispatch(createResourceSuccess({ data: response.data }));
            history.push('/organisation');
            dispatch(getResource());

        } catch (error) {
            console.log("Error****:", error);
            if (error.response) {
                // console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                const { statusCode, message: msg } = error.response.data;
                if (msg)
                    message.error(msg);
            }
            dispatch(fetchError(error));
        }
    }
};

export const updateResource = (payload, id) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {

            let formData = new FormData();
            // formData.append('name', payload.name);
            // formData.append('filesFavicon', payload.filesFavicon.file);

            formData.append('files', payload.files.file);
            formData.append('filesFavicon', payload.filesFavicon.file);

            Object.keys(payload).forEach(key => {
                if (key === 'files' || key === 'filesFavicon') {
                    return
                }
                formData.append(key, payload[key]);
            });

            await axios.put(`/common/organisation/update/${id}`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
            dispatch(fetchSuccess());
            history.push('/organisation');
            dispatch(getResource());
        } catch (error) {
            console.log("Error****:", error);
            dispatch(fetchError(error.response.data.message));
        }
    }
};


export const fetchResource = (id) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            const response = await axios.get(`/organisation/${id}`);
            dispatch(fetchSuccess());
            dispatch(fetchResourceSuccess({ data: response.data }));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const deleteResource = (id) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            await axios.delete(`/organisation/${id}`);
            dispatch(fetchSuccess());
            dispatch(getResource());
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const assetMasterImport = (payload) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            let formData = new FormData();
            formData.append('organisation', payload.organisation);
            formData.append('files', payload.file);

            const response = await axios.post(`/common/master-import`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
            // console.log(response);
            dispatch(fetchSuccess());
            if (response && response.data && response.data.code === 200) {
                const { data } = response.data;
                // console.log(data);
                // message.success(`${data.length} - record created`);
                // downloadJSONFile({
                //   data: JSON.stringify(data, null, 1),
                //   fileName: 'pi-import' + new Date().getTime() + '.json',
                //   fileType: 'text/json',
                // });
                // console.log(JSON.stringify(data, null, 1));
                Swal.fire({
                    title: `<strong>Data Import </strong>`,
                    html: `<div><p>Type : ${data.typeCount}, SubType: ${data.subTypeCount}, Model: ${data.modelCount}, Make: ${data.makeCount}</p></div>`,
                    icon: 'success'
                });
                dispatch(fetchImportSuccess(data));
            } else if (response && response.data && response.data.code === 401) {
                message.error(`Something went wrong, please verify results in Master`);
            }
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    }
};

export const spareMasterImport = (payload) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            let formData = new FormData();
            formData.append('organisation', payload.organisation);
            formData.append('files', payload.file);

            const response = await axios.post(`/common/spare-import`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
            // console.log(response);
            dispatch(fetchSuccess());
            if (response && response.data && response.data.code === 200) {
                const { data, count } = response.data;
                console.log(data);
                // message.success(`${data.length} - record created`);
                // downloadJSONFile({
                //   data: JSON.stringify(data, null, 1),
                //   fileName: 'pi-import' + new Date().getTime() + '.json',
                //   fileType: 'text/json',
                // });
                // console.log(JSON.stringify(data, null, 1));
                Swal.fire({
                    title: `<strong>Data Import </strong>`,
                    html: `<div><p>data imported!</p></div>`,
                    icon: 'warning'
                });
                dispatch(fetchSpareImportSuccess(data));
            } else if (response && response.data && response.data.code === 401) {
                message.error(`Something went wrong, please verify results in Master`);
            }
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    }
};

export const organisationDataRemove = (payload) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const { isRemove } = payload;
            if (isRemove) {
                console.log(`Organisation data removing...`);
                // const response = await axios.get(`/purchase-order/reverse-import/${payload.organisation}`);
                await axios.get(`/security/remove/${payload.organisation}`);
                // console.log(JSON.stringify(response.data, null, 1));
                // message.success(`Organisation data will remove in background!`);
                Swal.fire({
                    title: 'Organisation Data',
                    html: `<div>All Organisation data will be removed! <p><small>Any new request will only execute after 15 min!</small></p></div>`,
                    icon: 'warning'
                })
                dispatch(fetchSuccess());
            } else dispatch(fetchSuccess());
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    }
};
